
<main-form-modal (toggleChange)="setVal($event)"> 
    <ng-template #customHtmlElements>
        <div [ngSwitch]="editMode">
           
            <registrationEvent-edit *ngSwitchCase="true"></registrationEvent-edit>
            <registrationEvent-details *ngSwitchCase="false"></registrationEvent-details>
        </div>
    </ng-template>  
</main-form-modal>